export enum ClassNames {
  PREVENT_SCROLL = 'prevent-scroll'
}
